import Link from "next/link";
import { useRouter } from "next/router";
import SearchIcon from "components/IconsSvg/SearchIcon";

export default function LocaleSwitcher() {
  const {
    locales,
    locale: activeLocale,
    pathname,
    query,
    asPath,
  } = useRouter();
  const otherLocales = locales.filter(locale => locale !== activeLocale);

  return (
    <>
      {otherLocales.map(locale => {
        return (
          <Link
            href={{ pathname, query }}
            as={asPath}
            locale={locale}
            key={locale}
          >
            <a className={"localSwitcher"}>{locale === "en" ? "En" : "Fa"}</a>
          </Link>
        );
      })}
    </>
  );
}
